import { DataObjectSchemasService } from 'services/dataObjectSchemas';
import type { TQTabView } from 'components/TQDataGrid/utils/grid-types';
import type { DataObjectSchema } from 'types/dataObjectSchemas';
import type { StringifiedUUID } from 'types';

const getDataObjectSchemaId = (schemas: DataObjectSchema[], type: DataObjectSchema['type']) =>
  schemas.find((schema) => schema.type === type)?.id;

type DataObjectSchemaParams = {
  tqModelId: StringifiedUUID;
  territoryViewId?: StringifiedUUID | null;
  dataObjectId: StringifiedUUID;
};

type DataObjectSchemaOptions = {
  includeExportable?: boolean;
  forCompare?: boolean;
  enabled?: boolean;
};

export const useDataObjectSchema = (
  type: TQTabView,
  { tqModelId, territoryViewId, dataObjectId }: DataObjectSchemaParams,
  { includeExportable, forCompare, enabled = true }: DataObjectSchemaOptions = {},
) => {
  const { query: dataObjectSchemasQuery } = DataObjectSchemasService.useGetDataObjectSchemasQuery(tqModelId, {
    territoryViewId,
  });
  const schemas = dataObjectSchemasQuery.data?.data || [];
  const accountsSchemaId = getDataObjectSchemaId(schemas, type);
  const { query, invalidateQuery } = DataObjectSchemasService.useGetDataObjectSchemaQuery(
    tqModelId,
    accountsSchemaId ?? '',
    dataObjectId,
    { territoryViewId, includeExportable, forCompare, enabled: !!accountsSchemaId && enabled },
  );

  return {
    isLoading: dataObjectSchemasQuery.isLoading || query.isLoading,
    dataObjectSchema: query.data,
    invalidateQuery,
  };
};
